import { Component, EventEmitter, Output } from '@angular/core';
import { MapLocation } from '../utils/dashboard-map-types';

@Component({
  selector: 'app-map-search-navigation',
  standalone: false,
  
  templateUrl: './map-search-navigation.component.html',
  styleUrl: './map-search-navigation.component.scss'
})
export class MapSearchNavigationComponent {
  matchedList: L.Marker[] = [];
  @Output() markerChanged = new EventEmitter<L.Marker>();

  currentIndex: number = 0;
  infoText: {
    full: string,
    before?: string,
    highlight?: string,
    after?: string
  } = {full: ''};
  private searchText: string = '';

  activate(matchedList: L.Marker[], searchText: string) {
    this.matchedList = matchedList;
    this.searchText = searchText;
    this.currentIndex = 0;
    this.emitCurrentMarker();
    this.updateInfoText();
  }

  deactivate() {
    this.currentIndex = 0;
    this.matchedList = [];
    this.searchText = '';
    this.updateInfoText();
  }

  get hasPrev(): boolean {
    return this.currentIndex > 0;
  }

  get hasNext(): boolean {
    return this.currentIndex < this.matchedList.length - 1;
  }

  onPrev() {
    if (this.hasPrev) {
      this.currentIndex--;
      this.updateInfoText();
      this.emitCurrentMarker();
    }
  }

  onNext() {
    if (this.hasNext) {
      this.currentIndex++;
      this.updateInfoText();
      this.emitCurrentMarker();
    }
  }

  private emitCurrentMarker() {
    this.markerChanged.emit(this.matchedList[this.currentIndex]);
  }

  private updateInfoText() {
    this.infoText = { full: '' };

    const currentMarker = this.matchedList[this.currentIndex];
    const location: MapLocation = (currentMarker as any)?._locationData;

    if(!location) { return; }

    if (location.licensePlate?.toLowerCase().includes(this.searchText)) {
      this.splitFoundText(location.licensePlate);
    } else if (location.vehicleNo?.toLowerCase().includes(this.searchText)) {
      this.splitFoundText(location.vehicleNo);
    } else if (location.protocolNo?.toLowerCase().includes(this.searchText)) {
      this.splitFoundText(location.protocolNo);
    }
  }
  
  private splitFoundText(fullText: string) {
    const startIndex = fullText.toLowerCase().indexOf(this.searchText);
    this.infoText = {
      full: fullText,
      before: fullText.substring(0, startIndex),
      highlight: fullText.substring(startIndex, startIndex + this.searchText.length),
      after: fullText.substring(startIndex + this.searchText.length)
    };
  }
}
